import Icons from '@common/components/Icons.tsx'
import {TextButton} from '@common/components/form/button/Button'
import {AchievementWorkshop as Workshop, getImageUrl} from '@common/types'
import clsx from 'clsx'
import moment from 'moment/moment'
import {useState} from 'react'

type Props = {
    allWorkshopFields: {[key: string]: string}
    baseUrl: string
    item: Workshop
}

export default function WorkshopSingle(props: Props) {
    const {allWorkshopFields, baseUrl, item} = props

    const [isOpen, setIsOpen] = useState(false)

    const onToggle = () => {
            setIsOpen(!isOpen)
        },
        onClose = () => {
            setIsOpen(false)
        }

    const cn = clsx({'workshop-detail !hidden': !isOpen})

    const arrowBtnCN = clsx('right-arrow-icon hidden lg:block lg:inset-y-center lg:right-0px mr-6px', {
        'lg:transform rotate-90': isOpen,
    })

    const featuredImage = item.featured_image
        ? getImageUrl(item.featured_image, 'medium_large', baseUrl)
        : {
              url: '',
              width: '',
              height: '',
          }

    console.log('item', item);

    return (
        <li className="workshop-list-item bg-gray-100 p-8px lg:bg-transparent lg:p-0px lg:rounded-0px lg:border-b-gray lg:border-b-1px lg:border-dashed lg:border-gray-600 lg:py-18px">
            <div
                className="inner py-24px px-16px flex flex-col gap-10px lg:bg-transparent lg:gap-0px lg:relative lg:cursor-pointer lg:p-0px"
                onClick={onToggle}
            >
                <div className="selectedStatuses flex items-center gap-6px lg:mb-12px">
                    <span className="text-140 text-blue-main">{item.product}</span>
                </div>
                <h2 className="title text-160 font-700 lg:text-160 lg:font-700 lg:mb-22px">{item.title}</h2>
                <div className="date text-gray-600 text-140">{moment(item.date).format('YYYY. MM. DD.')}</div>
                <div className={arrowBtnCN}>{Icons.chevronRight}</div>
            </div>
            <div className={cn}>
                <div className="showcase-detail-inner flex flex-col gap-12px">
                    <div className="product flex flex-col gap-20px bg-[#D1F0F566] p-16px lg:p-16px">
                        <h3 className="flex gap-8px items-center">
                            {Icons.page}
                            <span className="text-160 font-700 lg:text-160 lg:font-700">개요</span>
                        </h3>
                        <div className="flex flex-col gap-20px lg:flex-row lg:gap-17px">
                            <div className="featured-image-container min-w-[30%] lg:max-w-[50%]">
                                {!!featuredImage.url && (
                                    <figure className="">
                                        <img
                                            alt={`"${item.title}" 게시물의 대표 이미지`}
                                            className="w-full"
                                            height={featuredImage.height}
                                            src={featuredImage.url}
                                            width={featuredImage.width}
                                        />
                                    </figure>
                                )}
                            </div>
                            <div className="outline-content">
                                <div className="text-160 font-400 lg:text-160" style={{whiteSpace: "pre-wrap"}} dangerouslySetInnerHTML={{ __html: item.outline }}></div>
                            </div>
                        </div>
                    </div>
                    <div className="content p-16px bg-[#D9F0EA66] lg:p-16px">
                        <h3 className="flex gap-8px items-center mb-11px lg:mb-20px">
                            {Icons.briefcase}
                            <span className="text-160 font-700 lg:text-160 lg:font-700">주요내용</span>
                        </h3>
                        <div className="content-body">
                            <div className="text-160 font-400 lg:text-160" style={{whiteSpace: "pre-wrap"}} dangerouslySetInnerHTML={{ __html: item.content }}></div>
                        </div>
                    </div>
                    <div className="flex justify-between items-center">
                        <div className="departments flex gap-16px items-center">
                            <div className="left text-140">
                                {/**
                                 * 소관기관 레이블에 소관기관을 적는 공간이나, 워크숍에는 '소관기관'이라는 필드는 없음.
                                 * 또한 참고로 현재 택소노미로 지정한 (아깝게도!) '문야' 필드는 프론트에 나오지 않는다.
                                 * 그러므로 대충 없는 값보다는 있는 값을 채워 넣음.
                                 */}
                                분야
                            </div>
                            <div className="right text-140 text-gray-600">{allWorkshopFields[item.field]}</div>
                        </div>
                        <div className="flex justify-end">
                            <TextButton onClick={onClose}>접기</TextButton>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    )
}
